/**
 * Preferencia del cursor animado de InvokeApp (public/assets/invokeapp-cursor/).
 * Se guarda en el navegador del visitante; si el almacenamiento falla, el cursor
 * queda activo y el interruptor funciona solo durante la visita.
 */
const KEY = 'invokeapp_cursor_disabled';
export const BRAND_CURSOR_EVENT = 'invokeapp-cursor-pref';

let memoryDisabled = null;

export const isBrandCursorDisabled = () => {
  if (memoryDisabled !== null) return memoryDisabled;
  try {
    return localStorage.getItem(KEY) === '1';
  } catch (_) {
    return false;
  }
};

export const setBrandCursorDisabled = (disabled) => {
  memoryDisabled = !!disabled;
  try {
    if (disabled) localStorage.setItem(KEY, '1');
    else localStorage.removeItem(KEY);
  } catch (_) {
    // Sin almacenamiento: vale para esta visita.
  }
  window.dispatchEvent(new CustomEvent(BRAND_CURSOR_EVENT, { detail: { disabled: !!disabled } }));
};

/** Solo tiene sentido con ratón (en táctil ni se descarga). */
export const brandCursorSupported = () =>
  typeof window !== 'undefined' &&
  !!window.matchMedia &&
  window.matchMedia('(hover: hover) and (pointer: fine)').matches;
